import React, { ReactElement } from 'react';
import ProTable, {
  esESIntl, enUSIntl, IntlProvider,
} from '@ant-design/pro-table';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import { Card } from 'antd';
import { Box } from '../components/basic';
import { ShowIf } from '../components';

export default function FiltrableProTable({
  columns,
  datasource,
  rowClick,
  toolBarRender,
  pagination,
  loading,
  expandedRowRender,
  onChange,
  headerTitle,
  setting,
  density,
  fullScreen,
  reload,
  form,
}) {
  const idioma = useSelector(state => state.app.idioma);

  return (
    <IntlProvider value={(() => {
      switch (idioma) {
        case 'es':
          return esESIntl;
        case 'en':
          return enUSIntl;
        default:
          return esESIntl;
      }
    })()}
    >
      <Box>
        <ShowIf condition={form}>
          <Box borderBottom="1px ridge">
            <Card bordered={false} bodyStyle={{ padding: '16px 0' }}>
              {form}
            </Card>
          </Box>
        </ShowIf>
        <ProTable
          rowKey="id"
          onRowClick={rowClick}
          params={{ keyword: '' }}
          loading={loading}
          options={{
            setting,
            density,
            fullScreen,
            reload,
            search: false,
          }}
          toolBarRender={() => toolBarRender()}
          expandedRowRender={expandedRowRender || null}
          pagination={pagination || false}
          search={false}
          columns={columns}
          dataSource={datasource}
          onChange={onChange}
          headerTitle={headerTitle}
          tableStyle={{
            overflowX: 'auto',
          }}
          rowClassName={() => 'pointer'}
        />
      </Box>
    </IntlProvider>
  );
}

FiltrableProTable.propTypes = {
  columns: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  datasource: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  rowClick: PropTypes.func,
  toolBarRender: PropTypes.func,
  pagination: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.shape({}),
  ]),
  loading: PropTypes.bool,
  expandedRowRender: PropTypes.oneOfType([
    PropTypes.bool,
    PropTypes.func,
  ]),
  onChange: PropTypes.func,
  headerTitle: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.objectOf(ReactElement),
  ]),
  setting: PropTypes.bool,
  density: PropTypes.bool,
  fullScreen: PropTypes.bool,
  reload: PropTypes.func,
  form: PropTypes.objectOf(ReactElement),
};

FiltrableProTable.defaultProps = {
  rowClick: () => {},
  toolBarRender: () => [],
  expandedRowRender: false,
  pagination: false,
  loading: false,
  onChange: () => {},
  headerTitle: '',
  setting: false,
  density: false,
  fullScreen: false,
  reload: false,
  form: null,
};
